import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import VideoCard from '@/components/base/VideoCard';
import ScrollToTop from '@/components/base/ScrollToTop';
import { categories } from '@/mocks/home';
import { categoryVideos } from '@/mocks/category';
import NotFound from '@/pages/NotFound';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  const currentCategory = categories.find((c) => c.slug === slug);
  const videos = slug ? categoryVideos[slug] : [];

  if (!currentCategory || !videos) {
    return <NotFound />;
  }

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '蜜桃在线', item: 'https://dicecho.cn' },
      { '@type': 'ListItem', position: 2, name: currentCategory.name },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          {/* Breadcrumb */}
          <Breadcrumb
            items={[
              { label: '首页', to: '/' },
              { label: currentCategory.name },
            ]}
          />
          {/* Category Header */}
          <div className="py-8 md:py-12">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600">
                <i className={`${currentCategory.icon} text-2xl md:text-3xl`}></i>
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-1">
                  {currentCategory.name}
                </h1>
                <p className="text-sm text-foreground-500">
                  {currentCategory.description}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-400">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-video-line"></i>
              </div>
              <span>共 {currentCategory.count.toLocaleString()} 部资源</span>
            </div>
          </div>
          {/* Category Tabs */}
          <div className="mb-8 overflow-x-auto">
            <div className="flex gap-2 pb-2 min-w-max">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200/70'
                  }`}
                >
                  <span className="flex items-center gap-1.5">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className={`${cat.icon} text-xs`}></i>
                    </div>
                    {cat.name}
                  </span>
                </Link>
              ))}
            </div>
          </div>
          {/* Video Grid */}
          <div className="pb-14 md:pb-20">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {videos.map((video) => (
                <VideoCard key={video.id} {...video} />
              ))}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}